module.exports = __webpack_public_path__ + "img/calendar.686dcc62.svg";